import lessRequire from '../../../../config/less-require-resolver';
import PropTypes from 'prop-types';
import React from 'react';
import { Field, reduxForm } from 'redux-form';

import InputField from '../../../shared/form-elements/input';
import TextAreaField from '../../../shared/form-elements/textarea';
import SelectField from '../../../shared/form-elements/select';
import AttachmentsField from '../../../shared/form-elements/attachments';

lessRequire('modules/tickets/list/components/create-ticket-form.less');

const Form = (props) => {
	const {
		handleSubmit,
		priorities,
		filesToUpload,
		addFileToUpload,
		removeFileFromUpload,
		createTicket,
		uploadError,
		formData,
		intl
	} = props;

	return (
		<form action="#" className="tickets-form clearfix" onSubmit={handleSubmit(data => {
			if (formData.isFromAdmin) {
				if (!confirm(intl('Вы пытаетесь добавить тикет от веба. Уверены?'))) {
					return;
				}
			}
			return createTicket(data);
		})}>
			<div className="tickets-form__row">
				<Field name="title"
					component={InputField}
					placeholder={intl('Тема вопроса')}
				/>
			</div>
			<div className="tickets-form__row">
				<Field name="priority"
					component={SelectField}
					options={priorities}
				/>
			</div>
			<div className="tickets-form__row">
				<Field name="text"
					component={TextAreaField}
					placeholder={intl('Текст сообщения')}
				/>
			</div>
			<div className="tickets-form__row upload-row">
				<Field name="file"
					component={AttachmentsField}
					placeholder={intl('Прикрепить файл')}
					info={intl('Общий размер загруженных файлов не более 5 МБ')}
					addFileToUpload={addFileToUpload}
					removeFileFromUpload={removeFileFromUpload}
					files={filesToUpload}
					maxSizeError={uploadError}
					intl={intl}
				/>
			</div>

			<Field component="input" type="hidden" name="offer_id"/>

			<div className="tickets-form__row submit-row">
				<button className="button yellow-btn font-proxima-nova-semibold">{intl('Отправить тикет')}</button>
			</div>
		</form>
	);
};

Form.propTypes = {
	handleSubmit: PropTypes.func,
	priorities: PropTypes.array,
	createTicket: PropTypes.func,
	addFileToUpload: PropTypes.func,
	removeFileFromUpload: PropTypes.func,
	filesToUpload: PropTypes.array,
	uploadError: PropTypes.bool,
	formData: PropTypes.object,
	intl: PropTypes.func
};

export default reduxForm({
	form: 'createTicketForm'
})(Form);



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/tickets/list/components/create-ticket-form.js